const themeNames = ['dawn', 'morning', 'midday', 'dusk', 'midnight'] as const;

export default themeNames;
